import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";
import User from "../models/User";

class UserManager extends ManagerBase {
	constructor () {
		super("userManager");
		this.remoteClassName = "user";
	}
	
	getCurent () {
		const rd = NousCore.api.createRequest();

		return NousCore.api.send("user/get-curent", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const operator = new User(data.items[0]);

						return {
							data: operator,
							status: "ok"
						};
					}
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}

	getOnboardingRequest (user) {
		const rd = NousCore.api.createRequest({ item: user || Shark.get("currUser") });

		return NousCore.api.send("pay-pal-payment/get-merchant-onboard-request", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							status: "ok"
						};
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}

	getOnboardingStatus (user) {
		const rd = NousCore.api.createRequest({ item: user || Shark.get("currUser") });

		return NousCore.api.send("pay-pal-payment/get-merchant-onboard-status", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							status: "ok"
						};
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}
	
	getStripeOnboardingRequest (user) {
		const rd = NousCore.api.createRequest({ item: user || Shark.get("currUser") });

		return NousCore.api.send("stripe-payment/get-merchant-onboard-request", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							status: "ok"
						};
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}

	getStripeOnboardingStatus (user) {
		const rd = NousCore.api.createRequest({ item: user || Shark.get("currUser") });

		return NousCore.api.send("stripe-payment/get-merchant-onboard-status", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							status: "ok"
						};
					case 404:
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}
	
	logIn (user) {
		const rd = NousCore.api.createRequest({ item: user.export("logIn") });

		return NousCore.api.send("user/login", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						user.clean();
						return {
							data: user,
							status: "ok"
						};
					case 404:
						return {
							data: null,
							status: "ko"
						};
				}
			}
		});
	}

	register (user) {
		const rd = NousCore.api.createRequest({ item: user.export() });
		const requestedAction = "register";

		return NousCore.api.send(`user/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						user.clean();

						return {
							data: user,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	requestNewPassword (user) {
		const rd = NousCore.api.createRequest({ item: user.export() });
		const requestedAction = "requestNewPassword";

		return NousCore.api.send(`user/${requestedAction}`, rd)
		.then(data => {
			console.log({data});
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: user,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	save (userList) {
		let actions = new Set();

		if (!Array.isArray(userList)) {
			userList = [userList];
		}

		userList.forEach(item => {
			actions.add(item.guid === "" ? "insert" : "update");
		});

		if (actions.size > 1) {
			alert("Non posso preosuguire");
			return;
		}
		
		const rd = NousCore.api.createRequest({ item: userList[0].export() });
		const action = Array.from(actions)[0];

		return NousCore.api.send(`user/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						userList.forEach((item, index) => {
							item.import(data.items[index]);
							item.clean();
						});

						return {
							data: userList,
							requestedAction: action,
							status: "ok",
						};
					case 99:
						return {
							data: null,
							requestedAction: action,
							status: "ko",
						};
				}
			}
		});
	}

	saveStatus (user) {
		const rd = NousCore.api.createRequest({ item: {status: user.status} });
		const requestedAction = "set-status";

		return NousCore.api.send(`user/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						user.import(data.items[0]);
						user.clean();

						return {
							data: null,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data: null,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	setNewPassword (user) {
		const rd = NousCore.api.createRequest({ item: {tempKey: Shark.get("tempKey"), ...user.export("logIn")} });
		const requestedAction = "set-new-password";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}
}

const userManager = new UserManager();

Shark.registerController(userManager);

export default userManager;
